<div
  class="wrapper"
  title="{{this.getDescription()}}"
  *ngIf="productId"
  (click)="toggleBookmark()"
  [ngClass]="{
    'with-description': this.displayDescription,
    'display-linear': this.displayLinear
    }">
  <div class="icon" role="button">
    <svg
      class="icon__svg"
      width="32" height="32"
      viewBox="0 0 32 32" fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [ngClass]="{
        'with-description': this.displayDescription,
        'filled': this.isBookmarked
      }">
      <path d="M22 6C19 6 17.3582 7.56873 16 8.94545C14.6418 7.56873 13 6 10 6C5.99964 6 4 9.35018 4 12.8727C4 18.804 11.0004 23.6727 16 25.6364C20.9996 23.6727 28 18.804 28 12.8727C28 9.35018 26.0004 6 22 6Z"
            stroke="#D6283D"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>
    <p *ngIf="displayDescription" class="description">
      {{this.getDescription()}}
    </p>
  </div>
</div>
